module.exports = __webpack_public_path__ + "img/icon27.c2279b87.png";